
import { printf, toText } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { fromParts, op_Multiply, toInt32 } from "../../fable_modules/fable-library-js.5.3.0/Decimal.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { display_inline$0027, display_hidden, fontSize_textSm, alignItems_itemsCenter, display_flex, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { space_spaceY1, textColor_textNeutral700, textColor_textNeutral500, sm, textColor_textNeutral400, gap_gap2 } from "../TailwindExtensions.js";
import { map, isEmpty, singleton, ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { createElement } from "react";
import { IconWeight, IconSize, IconName, icon } from "../Icons.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";

export function trancheLabel(condition) {
    switch (condition) {
        case "updatePosted":
            return "Post at least one update";
        case "pledgeReceived":
            return "Receive a supporting pledge";
        case "goalReached":
            return "Hit your goal";
        default:
            return "Milestone";
    }
}

function formatAmount(amount) {
    return toText(printf("$%.2f"))(amount);
}

function formatPercentage(percentage) {
    const arg = ~~toInt32(op_Multiply(percentage, fromParts(100, 0, 0, false, 0))) | 0;
    return toText(printf("%d%%"))(arg);
}

function row(tranche) {
    return HtmlHelper_createElement("li", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, gap_gap2, fontSize_textSm]))], ["children", [HtmlHelper_createElement("span", ofArray([["className", tw(singleton(textColor_textNeutral400))], ["children", [createElement(icon, {
        name: new IconName(31, []),
        size: new IconSize(0, []),
        weight: new IconWeight(0, []),
    })]]])), HtmlHelper_createElement("span", singleton(["children", singleton(trancheLabel(tranche.Condition))])), HtmlHelper_createElement("span", ofArray([["className", tw(ofArray([display_hidden, sm(display_inline$0027), textColor_textNeutral500]))], ["children", singleton(formatPercentage(tranche.Percentage))]])), HtmlHelper_createElement("span", ofArray([["className", tw(singleton(textColor_textNeutral700))], ["children", singleton(formatAmount(tranche.Amount))]]))]]]));
}

export function view(tranches) {
    if (isEmpty(tranches)) {
        return defaultOf();
    }
    else {
        return HtmlHelper_createElement("ul", ofArray([["className", tw(singleton(space_spaceY1))], ["children", map(row, tranches)]]));
    }
}

//# sourceMappingURL=FeeShareScheduleList.js.map
